import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  HelpBlock,
  FormGroup,
  FormControl,
  ControlLabel
} from 'react-bootstrap';

import LoaderButton from '../components/LoaderButton';
import { updateUserAttributes } from '../redux/actions/user';

import styles from './ChangeUserProfile.module.less';

class ChangeUserProfile extends Component {
  static propTypes = {
    user: PropTypes.object,
    updateUserAttributes: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      code: '',
      firstName: props.user.attributes['custom:first_name'],
      lastName: props.user.attributes['custom:last_name'],
      email: props.user.attributes.email,
      saved: false
    };
  }

  validatEmailForm() {
    return this.state.email.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleUpdateClick = async event => {
    event.preventDefault();
    const { user, updateUserAttributes } = this.props;

    updateUserAttributes(user, {
      email: this.state.email.trim(),
      'custom:first_name': this.state.firstName.trim(),
      'custom:last_name': this.state.lastName.trim()
    });

    this.setState({ saved: true });
  };

  renderUpdateForm() {
    return (
      <form onSubmit={this.handleUpdateClick}>
        <FormGroup bsSize="large" controlId="firstName">
          <ControlLabel>First Name</ControlLabel>
          <FormControl
            autoFocus
            type="text"
            value={this.state.firstName}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup bsSize="large" controlId="lastName">
          <ControlLabel>Last Name</ControlLabel>
          <FormControl
            type="text"
            value={this.state.lastName}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup bsSize="large" controlId="email">
          <ControlLabel>Email</ControlLabel>
          <FormControl
            type="email"
            value={this.state.email}
            onChange={this.handleChange}
          />
        </FormGroup>
        <LoaderButton
          block
          type="submit"
          bsSize="large"
          text="Update Profile"
          loadingText="Updating…"
          disabled={!this.validatEmailForm()}
        />
      </form>
    );
  }

  renderConfirmation() {
    return <HelpBlock>Your changes have been saved.</HelpBlock>;
  }

  render() {
    return (
      <div className={styles.changeEmail}>
        {!this.state.saved
          ? this.renderUpdateForm()
          : this.renderConfirmation()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return { user: state.user.userInfo };
};

const mapDispatchToProps = dispatch => {
  return {
    updateUserAttributes: (user, attributes) =>
      dispatch(updateUserAttributes(user, attributes))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeUserProfile);



// WEBPACK FOOTER //
// ./src/containers/ChangeUserProfile.js